import { Fragment } from "react";
import { ActionButton } from "Notifier";
import axios from "axios";

import t from "translations";

const randId = () => Math.random().toString(36).substring(2, 10);

const generateNotification = (notifications, text, variant, params) => ({
  notifications: [
    ...notifications,
    {
      text,
      variant,
      params,
      key: params?.key ?? randId(),
    },
  ],
});

const notifications = (store) => {
  store.on("@init", () => ({ notifications: [] }));
  store.on("notification/success", ({ notifications }, text, params) =>
    generateNotification(notifications, text, "success", params)
  );
  store.on("notification/error", ({ notifications }, data) => {
    if (typeof data === "string") {
      return generateNotification(notifications, data, "error");
    }
    const { text, err, params = {} } = data;
    let notificationText = text;
    if (!axios.isCancel(err)) {
      if (err?.response) {
        const { status, data } = err.response;
        notificationText = `${text} - ${data} [${status}]`;
      } else {
        notificationText = `${text} - ${err.message}`;
      }
    }
    return generateNotification(
      notifications,
      notificationText,
      "error",
      params
    );
  });
  store.on("notification/info", ({ notifications }, text, params) =>
    generateNotification(notifications, text, "info", params)
  );
  store.on("notification/warning", ({ notifications }, text, params) =>
    generateNotification(notifications, text, "warning", params)
  );

  store.on(
    "notification/unsavedEditor",
    ({ notifications, canvas, products }) =>
      generateNotification(notifications, t.unsavedDesign, "info", {
        key: "unsavedEditor",
        // anchorOrigin: {
        //   vertical: "bottom",
        //   horizontal: "right",
        // },
        autoHideDuration: 10000,
        customAction: (key, closeSnackbar) => (
          <Fragment>
            <ActionButton
              onClick={() => {
                const productId = parseInt(
                  localStorage.getItem("DeskpadEditorProductId"),
                  10
                );
                const productToRestore = products?.find(
                  (p) => p.id === productId
                );
                if (productToRestore) {
                  store.dispatch("product/set", productToRestore);
                  canvas?.DPE.persistent.loadFromStorage(() => {
                    store.dispatch("productSelector/close");
                    store.dispatch(
                      "notification/info",
                      t.canvasAndProductRestored
                    );
                    store.dispatch("canvas/autosave/on");
                    closeSnackbar(key);
                    store.dispatch("canvas/setEditorType");
                  });
                } else {
                  store.dispatch(
                    "notification/warning",
                    "Product no longer exits"
                  );
                  canvas?.DPE.persistent.loadFromStorage(
                    () => {
                      store.dispatch("notification/info", t.canvasRestored);
                      store.dispatch("canvas/autosave/on");
                      closeSnackbar(key);
                    },
                    true,
                    true
                  );
                }
              }}
            >
              {t.restoreDesign}
            </ActionButton>
            <ActionButton
              onClick={() => {
                closeSnackbar(key);
                store.dispatch("canvas/autosave/on");
              }}
            >
              {t.dismiss}
            </ActionButton>
          </Fragment>
        ),
      })
  );

  store.on("notification/removed", ({ notifications }, key) => {
    return { notifications: notifications.filter((obj) => obj.key !== key) };
  });
};

export default notifications;
